<template>
  <div class="wrap">
    <van-nav-bar style="background: #00AC70;" class="custom-nav-bar" title="基地信息" />
    <van-loading color="#00AC70" style="text-align: center;margin-top: 50%;" size="60" v-if="loading" text-size="20"
                 vertical>
      加载中...
    </van-loading>
    <div class="container">
      <div class="title">基地介绍</div>
      <div class="container-box">
        <div class="container-item base-container-item">
          <div class="desc company-name">{{baseInfo.name || '-'}}</div>
          <div class="desc user-name">
            <i class="icon user-icon"></i>
            {{baseInfo.principal || '-'}}
          </div>
          <div class="desc desc-text">
            <p>
              <i class="icon desc-icon"></i>
              <span>{{baseInfo.introduce || '-'}}</span>
            </p>
            <img v-if="!isLoadMore" :src="getFirstUrl(mainNoVideo[0])" alt="" @click="sceneImg(mainNoVideo,0)">
            <div v-if="isLoadMore">
              <img v-for="(more,moreIndex) in mainNoVideo" :key="moreIndex" :src="more" alt="" @click="sceneImg(mainNoVideo,moreIndex)">
            </div>
          </div>
          <div id="allmap" :style="{ width: '100%', height: '200px', marginBottom:'20px' }"></div>
          <div class="load-more" v-if="mainImagelist.length > 1" @click="isLoadMore = !isLoadMore">更多基地信息
            <van-icon :name="isLoadMore?'arrow-up':'arrow-down'" />
          </div>
        </div>
      </div>
      <div class="title">基地商品</div>
      <van-list v-model="listLoading" :finished="listFinished" :immediate-check="false" finished-text="没有更多了"
                @load="loadMore" :offset="10">
        <div class="container-box" v-for="(pro,proIndex) in productList" :key="proIndex">
          <div class="container-item base-container-item">
            <div class="desc company-name">{{pro.productName || '-'}}</div>
            <div class="desc desc-text">
              <img :src="getFirstUrl(pro.icon)" alt=""  @click="sceneImg([pro.icon],proIndex)">
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import {ImagePreview} from "vant";
export default {
  name: "baseInfo",
  data(){
    return{
      loading:false,
      isLoadMore: false,
      mainHasVideo: [],
      mainNoVideo: [],
      videoIndex: '',
      mainImagelist: [],
      baseInfo: {

      }, //基地信息
      page: 1,
      pageSize: 10,
      total: 0,
      listLoading: false,
      listFinished: false,
      productList:[],//基地商品
      baseId:'',//基地id
    }
  },
  watch: {
    /***Description 此处监听上传的数据是否包含视频来控制接下来上传的数据*/
    mainImagelist(val) {
      if (val) {
        console.log(val, '获取到接口的图片')
        let videoUrl = val.filter(img => {
          return img.indexOf('.mp4') !== -1
        });
        console.log(videoUrl, 'videoUrl')
        let noVideo = val.filter(img => {
          return img.indexOf('.mp4') === -1
        });
        console.log(noVideo, 'noVideo')
        let videoIndex = val.findIndex((item, index) => {
          return item.indexOf('.mp4') !== -1;
        });
        console.log(videoIndex, 'videoIndex')
        this.videoIndex = videoIndex;
        if (videoUrl.length > 0) {
          this.mainHasVideo = videoUrl;
        }
        this.mainNoVideo = noVideo;
        console.log(this.mainNoVideo, '基地图片======')
      }
    }
  },
  methods:{
    /**
     * 获取第一张图片
     */
    getFirstUrl(url) {
      return url ? url.split('~')[0] : ''
    },
    /**@Description: 图片预览*/
    sceneImg(images, index) {
      ImagePreview({
        images: images, //需要预览的图片 URL 数组
        showIndex: true, //是否显示页码
        loop: false, //是否开启循环播放
        closeable: true,
        startPosition: index //图片预览起始位置索引
      })
    },
    /** @Description:  基地详情*/
    async getBaseInfoById(){
      let getBaseInfo = (id) => this.$request.get(`/bases-consumer/miniProgram/base/queryById/${id}`);
      const result = await getBaseInfo(this.baseId);
      console.log(result,'111');
      this.baseInfo = result.data;
      this.initMap();
      if (this.baseInfo.picture) {
        this.mainImagelist = this.baseInfo.picture.split('~');
      }
    },
    /** @Description:  基地商品*/
    async getBaseProductById(){
      let params = {
      pageNum:this.page,pageSize:this.pageSize,params:{storeId: this.baseId}
      };
      let getBaseProduct = (params) => this.$request.post(`/orders-consumer/app/ordersProductInfo/queryPage`,params);
      const result = await getBaseProduct(params);
      console.log(result,'商品');
      let rows = result.data.rows;
      this.listLoading = false;
      this.total = result.data.totalCount;
      if (rows == null || rows.length == 0) {
        // 加载结束
        this.listFinished = true;
        return;
      }
      this.productList = this.productList.concat(rows);
      if (this.productList.length >= this.total) {
        this.listFinished = true;
      }
    },
    /**
     * 加载更多数据
     */
    loadMore() {
      this.page++;
      this.getBaseProductById()
    },
    /** @Description:  百度地图*/
    initMap(){
      const { longitude, latitude } = this.baseInfo;
      let map = new BMap.Map('allmap', { mapType: BMAP_HYBRID_MAP }, { enableMapClick: false }) // 创建Map实例
      map.centerAndZoom(new BMap.Point(longitude,latitude), 16) // 林埭镇
      map.setCurrentCity('衢州市') // 设置地图显示的城市 此项是必须设置的
      map.enableScrollWheelZoom(true);
      // 创建小车图标
      const icon = require('../assets/img/market.png')
      let myIcon = new BMap.Icon(icon, new BMap.Size(26, 50));

      let points = new BMap.Point(longitude, latitude) //创建坐标点
      let markersIcon = new BMap.Marker(points, {
        icon: myIcon
      })
      map.addOverlay(markersIcon)
    }
  },
  mounted() {
    document.title = '基地信息';
    if (this.$route.query.baseId) {
      this.baseId = this.$route.query.baseId;
      this.getBaseInfoById();
      this.getBaseProductById();
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  height: 80px;
  line-height: 80px;
  background: url("../assets/img/titleBj.png") no-repeat;
  background-size: contain;
  background-position: center;
  font-size: 30px;
  font-weight: bold;
  color: #333333;
  margin: 40px 0;
  text-align: center;
}

.container-box {
  margin: 20px;
  min-height: 637px;
  border: 1px solid #00AC70;
  padding: 10px;

  .container-item {
    padding: 22px;
    border: 1px solid #00AC70;
    min-height: 637px;
    font-size: 26px;
    position: relative;

    .desc {
      padding: 10px 0;
    }

    .company-name {
      font-size: 26px;
      color: #00AC70;
    }

    .user-name,
    .desc-text {
      color: #666666;
    }

    .icon {
      display: inline-block;
      width: 26px;
      height: 26px;
      margin-right: 10px;
      vertical-align: middle;
    }

    .user-icon {
      background: url("../assets/img/userIcon.png") no-repeat;
      background-size: 100% 100%;
    }

    .desc-icon {
      background: url("../assets/img/descIcon.png") no-repeat;
      background-size: 100% 100%;
    }

    img {
      width: 100%;
      height: 100%;
      border-radius: 16px;
      // margin: 20px 0;
    }

    .load-more {
      width: 100%;
      text-align: center;
    }

    .fram-wrok {
      height: 904px;
      background: #00AC70;
      border-radius: 10px;
    }

    .bottom-box {
      width: calc((100% - 40px));
      min-height: 260px;
      height: auto;
      background: linear-gradient(0deg, #009F68 0%, rgba(0, 159, 104, 0) 100%);
      border-radius: 10px;
      position: absolute;
      bottom: 22px;

      .fram-desc {
        color: #ffffff;
        font-size: 26px;
        position: absolute;
        bottom: 0;
        padding: 0 20px;

        &>div {
          padding: 15px 0;
        }
      }
    }

    .fram1 {
      background: url("../assets/img/fram1.png") no-repeat;
      background-size: 100% 100%;
    }

    .fram2 {
      background: url("../assets/img/time.png") no-repeat;
      background-size: 100% 100%;
    }

    .farm3 {
      background: url("../assets/img/address_icon.png") no-repeat;
      background-size: 100% 100%;
    }

    .farm5 {
      background: url("../assets/img/weather_icon.png") no-repeat;
      background-size: 100% 100%;
    }

    .video-item {
      width: 100%;
      height: 1104px;
      object-fit: fill;
    }

    .video-box {
      .play-icon {
        width: 100px !important;
        height: 100px !important;
        background: url(../assets/img/play.png) no-repeat;
        background-size: cover;
        z-index: 1000;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .base-container-item {
    img {
      margin: 20px 0;
    }
  }
}
</style>